export default __webpack_public_path__ + "assets/times-442662a.svg";